import { useEffect, useState } from 'react';
import { fetchResidents, fetchGoals } from '../../api';
import { ResidentCard } from '../../components/ResidentCard';
import { GoalCard } from '../../components/GoalCard';
import type { DonationGoal, Resident } from '@zs/shared/schema';

export default function JapanHome() {
  const [residents, setResidents] = useState<Resident[]>([]);
  const [goals, setGoals] = useState<DonationGoal[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([fetchResidents(), fetchGoals()])
      .then(([residentsData, goalsData]) => {
        setResidents(residentsData || []);
        setGoals(goalsData || []);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="loading">読み込み中...</div>;
  }

  return (
    <div className="home-page">
      <section className="hero">
        <h1>🐕 ようこそ ZS動物シェルター 🐈</h1>
        <p>保護動物たちの温かい出会いを待っています</p>
      </section>

      {goals.length > 0 && (
        <section>
          <div className="section-header">
            <span className="sparkle">✨</span>
            <h2>寄付目標額</h2>
            <span className="sparkle">✨</span>
          </div>
          <div className="goals-grid">
            {goals.map((goal: DonationGoal) => (
              <GoalCard key={goal._id} goal={goal} />
            ))}
          </div>
        </section>
      )}

      <section>
        <div className="section-header">
          <span className="sparkle">⭐</span>
          <h2>注目のメンバー</h2>
          <span className="sparkle">⭐</span>
        </div>
        {residents.length === 0 ? (
          <p style={{textAlign: 'center', padding: '20px', color: '#999'}}>
            現在、メンバーがいません。
          </p>
        ) : (
          <div className="residents-grid">
            {residents.slice(0, 6).map((resident: Resident) => (
              <ResidentCard key={resident._id} resident={resident} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
